import * as propz from 'propz';
import { Tournament } from 'models/tournament';

export const TV_PREFIX = 'tv_';

export function getDomainParts() {
   return document.location.host.split('.').slice();
}

export function getProtocol() {
   return `${document.location.protocol}//`;
}

export function getTournamentPublicSiteLink(tournament: Tournament): string {
   const tournamentDomain = propz.get(tournament, ['domain'], '');
   const domainParts = getDomainParts();

   if (typeof tournamentDomain !== 'undefined') {
      domainParts.splice(0, 1, tournamentDomain);
      return getProtocol() + domainParts.join('.');
   } else {
      return '';
   }
}

export function getPublicSiteLink(domain: string): string {
   const domainParts = getDomainParts();

   if (typeof domain !== 'undefined') {
      domainParts.splice(0, 1, domain);
      return getProtocol() + domainParts.join('.');
   } else {
      return '';
   }
}

export function getOfficialWebsiteLink(link: string): string {
   const value = String(link || '').trim();

   if (value === '') {
      return '';
   }

   if (/^https?:\/\//i.test(value)) {
      return value.replace(/^http:\/\//i, 'https://');
   }

   if (value.includes('.') || value.includes('/') || value.includes(':')) {
      return `https://${value.replace(/^\/\//, '')}`;
   }

   const environment = document.location.hostname.match(/(?:^|\.)(stage1|preprod)\.squadintouch\.com$/i)?.[1];
   const platformDomain = environment
      ? `${environment}.squadintouch.com`
      : 'squadintouch.com';

   return `https://${value}.${platformDomain}`;
}

export function getTournamentTVPublicSiteLink(tournament: Tournament): string {
   const tournamentDomain = propz.get(tournament, ['domain'], '');
   const domainParts = getDomainParts();

   if (typeof tournamentDomain !== 'undefined') {
      domainParts.splice(0, 1, tournamentDomain);
      return getProtocol() + TV_PREFIX + domainParts.join('.');
   } else {
      return '';
   }
}
